import { Link } from "react-router-dom";
import { ArrowUpRight, MapPin } from "lucide-react";
import Seo from "@/components/Seo";
import { MaskLines, Reveal, SectionHead } from "@/components/Reveal";
import { REGIONS, citiesByRegion } from "@/data";
import { CY_LOCATIONS as T } from "@/data/cy";
import { CY_CITY_SLUGS } from "@/data/cy-cities";

const WelshLocations = () => (
  <div data-testid="locations-cy-page">
    <Seo title={T.seoTitle} description={T.seoDesc} lang="cy" path="/cy/lleoliadau" altEn="/locations" />
    <section className="border-b border-[#1C2027] bg-[#0D1015] pb-16 pt-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <p className="eyebrow flex items-center gap-3">
          <span className="h-px w-10 bg-[#F5A800]" />
          {T.eyebrow}
        </p>
        <MaskLines className="font-condensed mt-6 text-5xl font-bold uppercase leading-[0.9] tracking-tight text-white sm:text-7xl" lines={T.h1} />
        <Reveal delay={0.3}>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-[#9BA1AB] sm:text-lg">{T.sub}</p>
        </Reveal>
      </div>
    </section>

    <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6">
      {REGIONS.map((region, ri) => (
        <div key={region} className="mb-14" data-testid={`region-cy-${ri}`}>
          <SectionHead index={String(ri + 1).padStart(2, "0")} eyebrow={region} title={region} testid={`region-cy-heading-${ri}`} />
          <div className="mt-8 grid gap-px border border-[#1C2027] bg-[#1C2027] sm:grid-cols-2 lg:grid-cols-3">
            {citiesByRegion(region).map((c, i) => (
              <Reveal key={c.slug} delay={(i % 3) * 0.07} y={14} className="h-full">
                <Link to={CY_CITY_SLUGS.has(c.slug) ? `/cy/lleoliadau/${c.slug}` : `/locations/${c.slug}`} data-testid={`location-cy-card-${c.slug}`} className="group flex h-full flex-col justify-between bg-[#10131A] p-6 transition-colors duration-300 hover:bg-[#161A22]">
                  <div>
                    <div className="flex items-start justify-between">
                      <h3 className="font-condensed text-2xl font-bold uppercase tracking-wide text-white transition-colors duration-300 group-hover:text-[#F5A800]">{c.name}</h3>
                      <ArrowUpRight className="h-4 w-4 text-white/30 transition-all duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 group-hover:text-[#F5A800]" />
                    </div>
                    <p className="mt-1 flex items-center gap-1.5 text-[11px] uppercase tracking-[0.2em] text-[#F5A800]/70">
                      <MapPin className="h-3 w-3" />
                      {c.county}
                    </p>
                    <p className="mt-3 text-[13px] leading-relaxed text-[#9BA1AB]">{c.tag}</p>
                  </div>
                  <span className="mt-5 text-[10px] font-bold uppercase tracking-[0.24em] text-white/40 transition-colors duration-300 group-hover:text-[#F5A800]">
                    {T.viewTown} {c.name} →
                  </span>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      ))}
    </section>
  </div>
);

export default WelshLocations;
